
    import "src/app/AppAdmin/Admin/index.module.scss?farm_css_modules";
    
    export default {"form": `form-44c26911`}
    